<template>
  <div class="customer-home">
    <el-container>
      <!-- 顶部导航 -->
      <el-header class="header">
        <div class="header-left">
          <h2>客户端 - 永盛制冷维修有限公司</h2>
        </div>
        <div class="header-right">
          <el-dropdown @command="handleCommand">
            <span class="user-info">
              <i class="el-icon-user"></i>
              {{ currentUser.name }}
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      
      <!-- 公告栏 -->
      <AnnouncementBar />
      
      <!-- 主内容区 -->
      <el-main class="main-content">
        <div class="welcome-section">
          <div class="welcome-content">
            <h1>欢迎回来，{{ currentUser.name }}！</h1>
            <p>您可以在这里提交维修申请和查看工单状态</p>
            <div class="welcome-decoration"></div>
          </div>
        </div>

        <!-- 数据统计 -->
        <el-row :gutter="20" class="stats-row">
          <el-col :span="8">
            <el-card class="stat-card" shadow="hover">
              <div class="stat-content">
                <div class="stat-icon pending">
                  <i class="el-icon-document"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-number">{{ customerStats.totalOrders }}</div>
                  <div class="stat-label">总工单数</div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="stat-card" shadow="hover">
              <div class="stat-content">
                <div class="stat-icon processing">
                  <i class="el-icon-loading"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-number">{{ customerStats.inProgress }}</div>
                  <div class="stat-label">进行中</div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="stat-card" shadow="hover">
              <div class="stat-content">
                <div class="stat-icon completed">
                  <i class="el-icon-circle-check"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-number">{{ customerStats.completed }}</div>
                  <div class="stat-label">已完成</div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <div class="quick-actions">
          <h2>快捷操作</h2>
          <el-row :gutter="20" class="action-row">
            <el-col :span="8">
              <el-card class="action-card" shadow="hover" @click.native="$safeRouter.push('/customer/create-order')">
                <div class="card-content">
                  <div class="action-icon">
                    <i class="el-icon-plus"></i>
                  </div>
                  <h3>创建工单</h3>
                  <p>提交新的维修申请</p>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="action-card" shadow="hover" @click.native="$safeRouter.push('/customer/orders')">
                <div class="card-content">
                  <div class="action-icon">
                    <i class="el-icon-document"></i>
                  </div>
                  <h3>我的工单</h3>
                  <p>查看工单状态和历史</p>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="action-card contact-card" shadow="hover">
                <div class="card-content">
                  <div class="action-icon">
                    <i class="el-icon-phone"></i>
                  </div>
                  <h3>联系客服</h3>
                  <p>📞 13471579359</p>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        
        <div class="recent-orders" v-if="recentOrders.length > 0">
          <h2>最近的工单</h2>
          <el-table :data="recentOrders" style="width: 100%">
            <el-table-column prop="id" label="工单号" width="100"></el-table-column>
            <el-table-column prop="appliance_type" label="家电类型" width="120"></el-table-column>
            <el-table-column prop="problem_description" label="问题描述" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="getStatusType(scope.row.status)">
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="created_at" label="创建时间" width="180">
              <template slot-scope="scope">
                {{ formatDate(scope.row.created_at) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-main>
    </el-container>
    
    <!-- 弹窗公告 -->
    <AnnouncementPopup />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AnnouncementBar from '@/components/AnnouncementBar.vue'
import AnnouncementPopup from '@/components/AnnouncementPopup.vue'

export default {
  components: {
    AnnouncementBar,
    AnnouncementPopup
  },
  name: 'CustomerHome',
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['currentUser']),
    recentOrders() {
      return this.$store.state.orders.slice(0, 5)
    },
    customerStats() {
      const orders = this.$store.state.orders || []
      return {
        totalOrders: orders.length,
        inProgress: orders.filter(order =>
          ['pending', 'accepted', 'in_progress'].includes(order.status)
        ).length,
        completed: orders.filter(order =>
          order.status === 'completed'
        ).length
      }
    }
  },
  async created() {
    await this.$store.dispatch('fetchCustomerOrders')
  },
  methods: {
    async handleCommand(command) {
      if (command === 'logout') {
        try {
          await this.$confirm('确定要退出登录吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })

          const result = await this.$store.dispatch('logout')

          if (result.success) {
            this.$message.success('退出登录成功')
            this.$safeRouter.push('/login')
          }
        } catch (error) {
          // 用户取消退出
          console.log('用户取消退出登录')
        }
      }
    },
    getStatusType(status) {
      const statusMap = {
        'pending': 'warning',
        'accepted': 'info',
        'in_progress': 'primary',
        'completed': 'success',
        'cancelled': 'danger'
      }
      return statusMap[status] || 'info'
    },
    getStatusText(status) {
      const statusMap = {
        'pending': '待接单',
        'accepted': '已接单',
        'in_progress': '维修中',
        'completed': '已完成',
        'cancelled': '已取消'
      }
      return statusMap[status] || '未知状态'
    },
    formatDate(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.customer-home {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.header {
  background-color: #409EFF;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-left h2 {
  margin: 0;
}

.user-info {
  cursor: pointer;
  color: white;
  font-size: 14px;
}

.user-info:hover {
  opacity: 0.8;
}

.main-content {
  padding: 20px;
  padding-bottom: 80px;
}

.welcome-section {
  text-align: center;
  margin-bottom: 30px;
  padding: 40px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.welcome-content h1 {
  color: #303133;
  margin-bottom: 15px;
  font-size: 2.2rem;
  font-weight: 700;
}

.welcome-content p {
  color: #606266;
  font-size: 16px;
  margin-bottom: 20px;
}

.welcome-decoration {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, transparent, #409EFF, transparent);
  margin: 0 auto;
  border-radius: 2px;
}

.stats-row {
  margin-bottom: 30px;
}

.stat-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 16px;
  overflow: hidden;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.stat-content {
  display: flex;
  align-items: center;
  padding: 25px;
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

.stat-icon i {
  font-size: 24px;
  color: white;
}

.stat-icon.pending {
  background: linear-gradient(135deg, #409EFF, #66B1FF);
}

.stat-icon.processing {
  background: linear-gradient(135deg, #E6A23C, #F7BA2A);
}

.stat-icon.completed {
  background: linear-gradient(135deg, #67C23A, #85CE61);
}

.stat-info {
  flex: 1;
}

.stat-number {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 14px;
  color: #909399;
}

.quick-actions {
  margin-bottom: 40px;
}

.quick-actions h2 {
  color: #303133;
  margin-bottom: 20px;
  font-size: 1.5rem;
  font-weight: 600;
}

.action-row {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.action-card {
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border-radius: 16px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  min-height: 200px;
}

.action-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 20px 40px rgba(64, 158, 255, 0.15);
  background: rgba(255, 255, 255, 0.98);
}

.card-content {
  text-align: center;
  padding: 35px 25px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.action-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #409EFF, #66B1FF);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.action-icon i {
  font-size: 2.5rem;
  color: white;
}

.action-card:hover .action-icon {
  transform: scale(1.1) rotateY(360deg);
  box-shadow: 0 8px 25px rgba(64, 158, 255, 0.3);
}

.card-content h3 {
  color: #303133;
  margin-bottom: 12px;
  font-size: 1.3rem;
  font-weight: 600;
}

.card-content p {
  color: #606266;
  font-size: 14px;
  line-height: 1.5;
}



.recent-orders {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.recent-orders h2 {
  color: #303133;
  margin-bottom: 20px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .customer-home {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    min-height: 100vh;
    padding-top: 0;
  }

  .header {
    height: auto !important;
    padding: 15px 20px !important;
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(20px);
    border-radius: 0 0 25px 25px;
    margin-bottom: 20px;
    box-shadow: 0 4px 25px rgba(0, 0, 0, 0.1);
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    position: sticky;
    top: 0;
    z-index: 100;
  }

  .header-left h2 {
    font-size: 16px !important;
    margin: 0;
    color: #2c3e50 !important;
    font-weight: 700;
    white-space: normal;
    word-break: break-word;
    line-height: 1.3;
    max-width: none;
  }

  .header-right {
    flex-shrink: 0;
  }

  .user-info {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    color: white !important;
    border-radius: 25px !important;
    padding: 8px 16px !important;
    font-size: 14px;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  }

  .main-content {
    padding: 10px 15px 80px 15px !important;
    background: transparent !important;
    position: relative;
    z-index: 1;
    overflow-x: hidden;
  }

  .welcome-section {
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(20px);
    border-radius: 20px !important;
    padding: 30px 25px !important;
    margin-bottom: 25px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  .welcome-section h1 {
    font-size: 26px !important;
    margin-bottom: 12px !important;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 700;
  }

  .welcome-section p {
    font-size: 15px !important;
    color: #6c757d !important;
    font-weight: 500;
  }

  /* 移动端统计卡片优化 */
  .stats-row {
    margin-bottom: 25px !important;
    display: flex !important;
    gap: 10px !important;
  }

  .stats-row .el-col {
    flex: 1 !important;
    min-width: calc(33.333% - 7px) !important;
    max-width: calc(33.333% - 7px) !important;
    width: calc(33.333% - 7px) !important;
    padding: 0 !important;
  }

  .stat-card {
    margin-bottom: 0 !important;
    background: linear-gradient(145deg, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.8)) !important;
    backdrop-filter: blur(20px);
    border-radius: 16px !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.4) !important;
    transition: all 0.3s ease;
    overflow: hidden;
    position: relative;
  }

  .stat-card::before {
    content: '';
    display: block;
    width: 100%;
    padding-top: 100%;
  }

  .stat-card::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #667eea, #764ba2);
    z-index: 1;
  }

  .stat-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 30px rgba(102, 126, 234, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.5) !important;
  }

  .stat-content {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    padding: 15px 10px !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    text-align: center !important;
    z-index: 2 !important;
  }

  .stat-icon {
    width: 40px !important;
    height: 40px !important;
    margin-right: 0 !important;
    margin-bottom: 10px !important;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12) !important;
    transition: all 0.3s ease;
    flex-shrink: 0;
  }

  .stat-card:hover .stat-icon {
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
  }

  .stat-info {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    text-align: center !important;
  }

  .stat-number {
    font-size: 20px !important;
    font-weight: 800 !important;
    background: linear-gradient(135deg, #2c3e50, #4a5568);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 4px !important;
  }

  .stat-label {
    font-size: 11px !important;
    color: #6c757d !important;
    font-weight: 600 !important;
    line-height: 1.2 !important;
  }

  .quick-actions {
    margin-bottom: 25px;
  }

  .quick-actions h2 {
    color: rgba(255, 255, 255, 0.9) !important;
    font-size: 18px !important;
    margin-bottom: 15px !important;
    text-align: center !important;
    font-weight: 600 !important;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .action-row {
    display: flex !important;
    gap: 10px !important;
    margin: 0 !important;
  }

  .action-row .el-col {
    flex: 1 !important;
    min-width: calc(33.333% - 7px) !important;
    max-width: calc(33.333% - 7px) !important;
    width: calc(33.333% - 7px) !important;
    margin-bottom: 0 !important;
    padding: 0 !important;
  }

  .action-card {
    margin-bottom: 0 !important;
    background: linear-gradient(145deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.7)) !important;
    backdrop-filter: blur(20px);
    border-radius: 16px !important;
    border: 2px solid rgba(255, 255, 255, 0.3) !important;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.4) !important;
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    position: relative;
    overflow: hidden;
  }

  .action-card::before {
    content: '';
    display: block;
    width: 100%;
    padding-top: 100%;
  }

  .action-card::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #667eea, #764ba2, #667eea);
    background-size: 200% 100%;
    animation: gradient-move 3s ease-in-out infinite;
    z-index: 1;
  }

  @keyframes gradient-move {
    0%, 100% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
  }

  .action-card:hover {
    transform: translateY(-4px) scale(1.05);
    box-shadow: 0 15px 40px rgba(102, 126, 234, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.6) !important;
    border-color: rgba(102, 126, 234, 0.4) !important;
  }

  .action-card .card-content {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    padding: 15px 10px;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .action-icon {
    width: 50px !important;
    height: 50px !important;
    margin: 0 auto 12px !important;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border-radius: 50% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3) !important;
    transition: all 0.3s ease !important;
    position: relative;
    overflow: hidden;
    flex-shrink: 0;
  }



  .action-card:hover .action-icon {
    transform: scale(1.1) rotateY(180deg);
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4) !important;
  }

  .action-card .card-content i {
    font-size: 28px !important;
    color: white !important;
    margin-bottom: 0 !important;
    transition: all 0.3s ease;
  }

  .action-card .card-content h3 {
    font-size: 14px;
    margin-bottom: 6px;
    background: linear-gradient(135deg, #2c3e50, #4a5568);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 700;
    letter-spacing: 0.3px;
    line-height: 1.2;
  }

  .action-card .card-content p {
    color: #6c757d !important;
    font-size: 11px !important;
    line-height: 1.3 !important;
    font-weight: 500 !important;
    margin-bottom: 0 !important;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  /* 联系客服卡片特殊处理 */
  .contact-card .contact-details {
    margin-top: 8px !important;
  }

  .contact-card .contact-method {
    justify-content: center !important;
    margin-bottom: 4px !important;
    font-size: 10px !important;
  }

  .contact-card .contact-method i {
    margin-right: 4px !important;
    font-size: 12px !important;
  }


}

/* 超小屏幕优化 */
@media (max-width: 380px) {
  .stats-row {
    gap: 8px !important;
  }

  .stats-row .el-col {
    min-width: calc(33.333% - 5px) !important;
    max-width: calc(33.333% - 5px) !important;
    width: calc(33.333% - 5px) !important;
  }

  .action-row {
    gap: 8px !important;
  }

  .action-row .el-col {
    min-width: calc(33.333% - 5px) !important;
    max-width: calc(33.333% - 5px) !important;
    width: calc(33.333% - 5px) !important;
  }

  .stat-content {
    padding: 12px 8px !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    z-index: 2 !important;
  }

  .action-card .card-content {
    padding: 12px 8px !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    z-index: 2 !important;
  }

  .stat-icon {
    width: 35px !important;
    height: 35px !important;
    margin-bottom: 8px !important;
  }

  .action-icon {
    width: 40px !important;
    height: 40px !important;
    margin-bottom: 8px !important;
  }

  .stat-number {
    font-size: 18px !important;
  }

  .stat-label {
    font-size: 10px !important;
  }

  .action-card .card-content h3 {
    font-size: 12px !important;
    margin-bottom: 4px !important;
  }

  .action-card .card-content p {
    font-size: 10px !important;
  }

  .contact-card .contact-method {
    font-size: 9px !important;
  }

  .main-content {
    padding: 8px 10px 80px 10px !important;
  }

  .welcome-section {
    padding: 20px 15px !important;
    margin-bottom: 20px !important;
  }

  .welcome-section h1 {
    font-size: 22px !important;
  }

  .welcome-section p {
    font-size: 13px !important;
  }
}

/* 极小屏幕处理 */
@media (max-width: 320px) {
  .stats-row {
    gap: 6px !important;
  }

  .stats-row .el-col {
    min-width: calc(33.333% - 4px) !important;
    max-width: calc(33.333% - 4px) !important;
    width: calc(33.333% - 4px) !important;
  }

  .action-row {
    gap: 6px !important;
  }

  .action-row .el-col {
    min-width: calc(33.333% - 4px) !important;
    max-width: calc(33.333% - 4px) !important;
    width: calc(33.333% - 4px) !important;
  }

  .stat-content {
    padding: 10px 6px !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    z-index: 2 !important;
  }

  .action-card .card-content {
    padding: 10px 6px !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    z-index: 2 !important;
  }

  .stat-icon {
    width: 30px !important;
    height: 30px !important;
  }

  .action-icon {
    width: 35px !important;
    height: 35px !important;
  }

  .stat-number {
    font-size: 16px !important;
  }

  .stat-label {
    font-size: 9px !important;
  }

  .action-card .card-content h3 {
    font-size: 11px !important;
  }

  .action-card .card-content p {
    font-size: 9px !important;
  }

  .main-content {
    padding: 5px 8px 80px 8px !important;
  }
}
</style>
